module.exports = __webpack_public_path__ + "img/官网-证书-出版.30d6d0b6.png";